import script from "./BoardPointsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardPointsModal.vue?vue&type=script&setup=true&lang=ts"

import "./BoardPointsModal.vue?vue&type=style&index=0&id=2ffb7329&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffb7329"],['__file',"BoardPointsModal.vue"]])

export default __exports__